import { PolygonPoints } from "@rio-cloud/rio-uikit/Polygon";
import { getRandomValueToForceRerender, ICoordinates, ISandboxMarker } from "src/components/Map";
import { decode } from "src/utils/flexiblePolyline";

export const mountPolyline = (polilyne: Array<string>) => {
  let ArrayOfShape: any[] = [];
  const getPolylineArray = polilyne.map((item) => {
    return {
      shape: decode(item),
    };
  });

  getPolylineArray.forEach((item) => {
    ArrayOfShape.push(item.shape.polyline);
  });

  const concatArrays = ArrayOfShape.flat();

  const getPoints = concatArrays.map((value) => {
    return {
      lat: value[0].toString(),
      lng: value[1].toString(),
    };
  });

  const markerDestination: ISandboxMarker = {
    id: getRandomValueToForceRerender().toString(),
    markerProps: {
      iconNames: ["truck"],
      name: "",
      markerColor: "bg-map-marker-asset",
      active: false,
      fixed: false,
    },
    position: {
      lat: getPoints[getPoints.length - 1].lat,
      lng: getPoints[getPoints.length - 1].lng,
    },
  };

  return { segments: getPoints, markerDestiny: markerDestination };
};

export const roundTo = (value: number, decimals: number) => {
   return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export const mountPolygonPoints = (points: PolygonPoints, originCoords: ICoordinates | null, coords: ICoordinates) => {
  return points?.map((point) => {
    const isSamePoint =
      point &&
      originCoords &&
      roundTo(point.lat, 3) === roundTo(originCoords.lat, 3) &&
      roundTo(point.lng, 3) === roundTo(originCoords.lng, 3);
    return isSamePoint ? { lat: coords.lat, lng: coords.lng } : point;
  });
};
